import { useEffect } from "react";

import { SEO_TITLE } from "./seo";

export const DEFAULT_PAGE_TITLE = SEO_TITLE;

export function usePageTitle(title) {
  useEffect(() => {
    const next = title || DEFAULT_PAGE_TITLE;
    document.title = next;
    return () => {
      document.title = DEFAULT_PAGE_TITLE;
    };
  }, [title]);
}
